import React, { useEffect, useState } from 'react';
import {
  Modal,
  Box,
  Typography,
  Checkbox,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Button,
  Divider,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

const VenueFilterModal = ({
  open,
  onClose,
  allVenues,
  selectedVenues,
  setSelectedVenues,
  city,
}) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const [tempSelected, setTempSelected] = useState([]);

  useEffect(() => {
    setTempSelected(selectedVenues);
  }, [selectedVenues, open]);

  const handleToggle = (venue) => {
    if (tempSelected.includes(venue)) {
      setTempSelected(tempSelected.filter((v) => v !== venue));
    } else {
      setTempSelected([...tempSelected, venue]);
    }
  };

  const handleSave = () => {
    setSelectedVenues(tempSelected);
    localStorage.setItem(
      `selectedVenues-${city}`,
      JSON.stringify(tempSelected),
    );
    onClose();
  };

  const handleClearAll = () => {
    setTempSelected([]);
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          borderRadius: 3,
          width: '95%',
          maxWidth: 480,
          maxHeight: '80vh',
          overflowY: 'auto',
        }}
      >
        <Typography variant="h6" fontWeight={600} mb={2}>
          {t('selectVenues')}
        </Typography>

        <List>
          {allVenues.map((venue) => (
            <ListItem
              key={venue}
              button
              onClick={() => handleToggle(venue)}
              sx={{ borderRadius: 1 }}
            >
              <ListItemIcon>
                <Checkbox
                  edge="start"
                  checked={tempSelected.includes(venue)}
                  tabIndex={-1}
                  disableRipple
                />
              </ListItemIcon>
              <ListItemText primary={venue} />
            </ListItem>
          ))}
        </List>

        <Divider sx={{ my: 2 }} />

        <Box display="flex" justifyContent="space-between">
          <Button onClick={handleClearAll}>{t('clearAll')}</Button>
          <Box display="flex" gap={2}>
            <Button onClick={onClose}>{t('cancel')}</Button>
            <Button
              variant="contained"
              onClick={handleSave}
              sx={{
                bgcolor: theme.palette.orange[700],
              }}
            >
              {t('save')}
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default VenueFilterModal;
